import React, { useState } from "react";
import { useMediaQuery, useTheme, CssBaseline, Box } from "@mui/material";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [headerWidth, setHeaderWidth] = useState('240px')  //240px

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <CssBaseline />
      <Header 
       handleDrawerToggle={handleDrawerToggle} 
       headerWidth={headerWidth}
      />  

      <Box sx={{ display: "flex", flex: 1 }}>      
        <Sidebar
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
          isMobile={isMobile}
        />    
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 0,
            width: { sm: `calc(100% - 240px)` },
            // ml: { sm: `240px` },
            mt: "64px", // Height of AppBar
          }}
        >
          <Outlet/>          
        </Box>
      </Box> 

      <Footer />
    </Box>
  );
};

export default MainLayout;